import { z } from "zod";
import { SupportedCurrencyCodesSchema } from "./currencies.js";
import { SupportedLanguageCodeSchema } from "./languages.js";
import { ParticipantSchema } from "./participants.js";
export const GroupSchema = z.strictObject({
    id: z.string().uuid(),
    label: z.string().min(1).max(120),
    currency: SupportedCurrencyCodesSchema,
    /**
     * Target language for scanned-receipt translation (issue #284). Always
     * present on a read: the service fills it with `DEFAULT_GROUP_LANGUAGE`
     * ("en") for groups created before the setting existed.
     */
    language: SupportedLanguageCodeSchema,
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    participants: z.array(ParticipantSchema),
});
/**
 * A group as returned by `GET /users/me/groups`. Superset of {@link
 * GroupSchema}: it carries the caller's net `balance` in the group's own
 * currency (minor units), positive when the caller is owed and negative when
 * they owe. `participants` is returned empty on this list route — the full
 * roster is fetched per-group — but the field is kept so a `GroupListItem`
 * stays assignable to `Group`.
 */
export const GroupListItemSchema = z.strictObject({
    id: z.string().uuid(),
    label: z.string().min(1).max(120),
    currency: SupportedCurrencyCodesSchema,
    language: SupportedLanguageCodeSchema,
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    participants: z.array(ParticipantSchema),
    /** Caller's net balance in this group's currency, in minor units. */
    balance: z.number().int(),
});
export const CreateGroupRequestSchema = z.strictObject({
    label: z.string().min(1).max(120),
    currency: SupportedCurrencyCodesSchema,
    /** Optional at creation; defaults to "en" server-side when omitted. */
    language: SupportedLanguageCodeSchema.optional(),
});
export const UpdateGroupRequestSchema = z.strictObject({
    label: z.string().min(1).max(120).optional(),
    currency: SupportedCurrencyCodesSchema.optional(),
    language: SupportedLanguageCodeSchema.optional(),
});
